import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgSignature(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m42.546 77.22.481.136-4.829 17.163a1.47 1.47 0 0 1-1.034 1.03l-.001-.001-17.025 4.867a.5.5 0 0 1-.62-.616l4.83-17.164c.135-.503.523-.89 1.025-1.027l17.036-4.869.137.48ZM29.44 87.944a2.479 2.479 0 0 0-2.469 2.489 2.48 2.48 0 0 0 2.47 2.489 2.48 2.48 0 0 0 2.468-2.49 2.479 2.479 0 0 0-2.469-2.488Z"
        fill="#B3C0D0"
      />
      <path
        d="M27.125 91.627a.8.8 0 0 1 1.137 1.127l-7.684 7.752a.8.8 0 0 1-1.136-1.126l7.683-7.752Z"
        fill="#0F172A"
      />
      <path
        d="M31.11 90.433a1.68 1.68 0 0 0-1.67-1.689 1.68 1.68 0 0 0-1.668 1.689c0 .938.753 1.69 1.669 1.69a1.68 1.68 0 0 0 1.669-1.69Zm1.6 0c0 1.81-1.458 3.289-3.27 3.289-1.81 0-3.268-1.48-3.268-3.29s1.458-3.287 3.269-3.287c1.811 0 3.27 1.478 3.27 3.288Z"
        fill="#0F172A"
      />
      <path
        d="M88.004 21.155c2.785-2.973 7.456-3.052 10.32-.158 2.874 2.893 2.805 7.604-.158 10.409l-56.37 53.516-6.894-6.942 53.102-56.825Z"
        fill="#78B441"
      />
      <path
        d="M87.64 20.813c2.977-3.178 7.975-3.265 11.04-.168 3.071 3.092 2.996 8.125-.17 11.123L41.785 85.622l-7.577-7.632 53.43-57.176.002-.002Zm10.329.536c-2.58-2.607-6.737-2.621-9.352-.104l-.248.251L35.596 77.97l6.209 6.254 56.017-53.18.251-.25c2.51-2.634 2.488-6.834-.104-9.444Z"
        fill="#78B441"
      />
      <path
        d="m88.28 21.085 9.965 10.044a1.383 1.383 0 0 1 0 1.946 1.36 1.36 0 0 1-1.925 0L86.355 23.03a1.383 1.383 0 0 1 0-1.945 1.359 1.359 0 0 1 1.926 0Z"
        fill="#00664F"
      />
      <path
        d="M86.002 20.733a1.859 1.859 0 0 1 2.491-.13l.142.13L98.6 30.775c.73.73.726 1.914.004 2.65l-.004.004-.001-.001a1.858 1.858 0 0 1-2.632 0l-.001-.001L86 23.383v-.001a1.882 1.882 0 0 1-.002-2.647l.004-.002Zm1.86.647a.858.858 0 0 0-1.153.06l-.001-.002a.885.885 0 0 0-.059 1.174l.06.066 9.964 10.043a.86.86 0 0 0 1.219 0 .883.883 0 0 0 0-1.238l-.001-.002-9.963-10.042-.067-.06Z"
        fill="#00664F"
      />
      <path
        d="m36.176 76.775 6.815 6.873a1.383 1.383 0 0 1 0 1.946 1.359 1.359 0 0 1-1.926 0L34.25 78.72a1.383 1.383 0 0 1 0-1.945 1.36 1.36 0 0 1 1.925 0Z"
        fill="#0F172A"
      />
      <path
        d="M33.897 76.422a1.859 1.859 0 0 1 2.492-.13l.141.13h.001l6.813 6.873c.73.73.726 1.913.004 2.65l-.004.002a1.859 1.859 0 0 1-2.633 0h-.001l-6.815-6.875a1.882 1.882 0 0 1-.002-2.647l.004-.003Zm1.86.647a.858.858 0 0 0-1.153.06v-.001a.885.885 0 0 0-.06 1.174l.06.065.001.001 6.813 6.872a.86.86 0 0 0 1.219 0 .883.883 0 0 0 0-1.238L42.636 84l-6.813-6.872-.066-.06ZM100.487 99.38a.8.8 0 1 1 0 1.6H42.22a.8.8 0 1 1 0-1.6h58.267ZM37.58 99.38a.8.8 0 0 1 0 1.6h-5.304a.8.8 0 1 1 0-1.6h5.303ZM27.96 99.38a.8.8 0 1 1 0 1.6h-1.323a.8.8 0 1 1 0-1.6h1.323Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgSignature)
